export default __webpack_public_path__ + "static/media/x.edb36b0b.svg";